module.exports = __webpack_public_path__ + "5a809a5ea559e4dad26e779b7bffacf8.png";